<template>
  <div class="dadianfied">
    <van-cell-group>
      <!-- <van-field v-model="title" label="教师姓名：" readonly /> -->
      <van-cell title="教师姓名：">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template class="youbiuja">
          {{title}}<span class="dltu" @click="tuichu">退出登录</span>
        </template>
      </van-cell>
      <van-field
        v-model="beginTime"
        required
        label="录课开始时间:"
        placeholder="选择时间"
        input-align="right"
        @click="show = true"
        readonly
      />
      <van-field
        v-model="endTime"
        required
        label="录课结束时间:"
        placeholder="选择时间"
        input-align="right"
        @click="show1 = true"
        readonly
      />
      <van-field
        v-model="subjec.name"
        label="所教学科:"
        placeholder="选择学科"
        input-align="right"
        @click="show2 = true"
        readonly
      />
      <van-field
        v-model="declar.name"
        required
        label="所在校区:"
        placeholder="选择您所在的校区"
        input-align="right"
        @click="show3 = true"
        readonly
      />
      <van-field
        v-model="grade.name"
        label="所教年级:"
        placeholder="选择年级"
        input-align="right"
        @click="show4 = true"
        readonly
      />
      <van-field
        v-model="courseAddress"
        required
        label="录课地点:"
        placeholder="请输入您的录课地点"
        input-align="right"
      />
      <van-field
        v-model="courseName"
        required
        label="课程名称:"
        placeholder="请填写您要录课的名称"
        input-align="right"
      />
      <van-field
        v-model="courseKeynote"
        required
        autosize
        type="textarea"
        label="课程介绍:"
        placeholder="请您从课程的目的，实现形式以及课程重点来简述一下课程"
        input-align="right"
      />
    </van-cell-group>
    <van-action-sheet v-model="show" title="">
      <van-datetime-picker
        v-model="timelist"
        type="datetime"
        @cancel="show = false"
        @confirm="endTimeChanges"
        @change="endTimeChange"
        title="录课开始时间"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-action-sheet>
    <van-action-sheet v-model="show1" title="">
      <van-datetime-picker
        v-model="timelist"
        type="datetime"
        @cancel="show = false"
        @confirm="endTimeChanges1"
        @change="endTimeChange1"
        title="录课结束时间"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-action-sheet>
    <van-action-sheet
      v-model="show2"
      :actions="subjectlist"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelect"
    />
    <van-action-sheet
      v-model="show3"
      :actions="declareselist"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel1"
      @select="onSelect1"
    />
    <van-action-sheet
      v-model="show4"
      :actions="gradelist"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel2"
      @select="onSelect2"
    />
    <van-cell
      title="课后反思"
      is-link
      v-if="$route.query.xq == 1"
      :value="datalist.courseReflect"
      @click="show5 = true"
    />
    <van-action-sheet v-model="show5" title="课后反思">
      <div class="content">
        <van-field
          v-model="datalist.courseReflect"
          rows="12"
          autosize
          type="textarea"
          placeholder="您的反思，能够帮助您改进教学，提高教学质量，促进学生发展，真诚的感谢您的辛苦付出！"
        />
      </div>
      <div class="pijkks">
        <span class="querenbaidi" @click="declareuploadCourseReflect"
          >提交课后反思</span
        >
      </div>
    </van-action-sheet>
    <van-row gutter="20" class="pin" style="color: #646566;">
      <van-col span="24" v-if="datalist.videoVoList&&datalist.videoVoList.length>0">
        录制视频：
      </van-col>
      <van-col span="24" v-for="(list,index) in datalist.videoVoList" :key="index">
        <van-col span="24"
            class="huisedi"
          >
            <van-col span="16">
              <span class="miuyuif1">{{ list.fileName }}</span>
            </van-col>
            <van-col span="8"  class="quxiaobaidi hjuis" @click="fuzhi(list)">复制地址</van-col>
          </van-col>
      </van-col>
    </van-row>
    <van-row gutter="20" class="tehj">
      <van-col span="12">
        <span class="quxiaobaidi" @click="quxiao">取消</span>
      </van-col>
      <van-col span="12">
        <span class="querenbaidi" @click="declaresaveDeclareVideoTape"
        v-if="$route.query.xq == 1"
          >编辑申报</span
        >
        <span class="querenbaidi" @click="declaresaveDeclareVideoTape"
        v-else
          >确认提交</span
        >
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {
  subjectgetSubjectBySchoolId,
  declareselectListByGroupId,
  gradegradelist,
  declaresaveDeclareVideoTape,
  declareuploadCourseReflect,
  usewxrlogout,
  siteurl
} from "@/api/home";
import { Toast } from "vant";
import Clipboard from "clipboard";
import { Dialog } from "vant";
export default {
  data() {
    return {
      title: "",
      show: false,
      minDate: new Date(2021, 0, 1),
      maxDate: new Date(2026, 10, 1),
      timelist:'',
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      subjectlist: [],
      subjec: {},
      declareselist: [],
      declar: {},
      gradelist: [],
      grade: {},
      beginTime: "",
      courseAddress: "",
      courseName: "",
      courseKeynote: "",
      endTime: "",
      datalist: [],
      violisy:''
    };
  },
  watch: {},
  components: {},
  methods: {
    endTimeChange(e) {
      let endTimeArr = e.getValues();
      this.beginTime = `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]}  ${endTimeArr[3]}:${endTimeArr[4]}:00`;
      let time=new Date(this.beginTime).getTime();
      if(this.endTime!==''){
        let time1=new Date(this.endTime).getTime();
        if(time1<time){
          Toast("开始时间，不能大于结束时间");
          this.beginTime=''
        }
      }
    },
    endTimeChanges(e) {
      if(this.timelist==''){
        this.timelist=new Date()
      }
      this.beginTime = this.formatDate(this.timelist);
      this.show = false;
    },
    endTimeChange1(e) {
      let endTimeArr = e.getValues();
      this.endTime = `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]}  ${endTimeArr[3]}:${endTimeArr[4]}:00`;
      let time=new Date(this.endTime).getTime();
      if(this.beginTime!==''){
        let time1=new Date(this.beginTime).getTime();
        if(time1>time){
          Toast("开始时间，不能大于结束时间");
          this.endTime=''
        }
      }
    },
    endTimeChanges1(e) {
      if(this.timelist==''){
        this.timelist=new Date()
      }
      this.endTime = this.formatDate(this.timelist);
      this.show1 = false;
    },
    formatDate(date) {
      var date = new Date(date);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    formatTen(s) {
      if (s < 10) {
        return "0" + s;
      } else {
        return s;
      }
    },
    subjectgetSubjectBySchoolId() {
      let that = this;
      let params = {
        schoolId: localStorage.getItem("schoolId"),
      };
      subjectgetSubjectBySchoolId(params)
        .then((res) => {
          that.subjectlist = res.data.data;
          if (that.$route.query.xq == 1) {
            for (var i = 0; i < that.subjectlist.length; i++) {
              if (that.subjectlist[i].id == that.datalist.subjectId) {
                that.subjec = that.subjectlist[i];
              }
            }
          }
        })
        .catch(() => {});
    },
    onCancel() {
      this.show2 = false;
    },
    onSelect(item) {
      this.subjec = item;
      this.show2 = false;
    },
    onCancel1() {
      this.show3 = false;
    },
    onSelect1(item) {
      this.declar = item;
      this.show3 = false;
    },
    onCancel2() {
      this.show4 = false;
    },
    onSelect2(item) {
      this.grade = item;
      this.show4 = false;
    },
    declareselectListByGroupId() {
      let that = this;
      let params = {
        // groupId: localStorage.getItem("groupId")
        groupId: 1,
      };
      declareselectListByGroupId(params)
        .then((res) => {
          that.declareselist = res.data.data;
          for (var i = 0; i < that.declareselist.length; i++) {
            that.declareselist[i].name = that.declareselist[i].campusName;
          }
          if (that.$route.query.xq == 1) {
            for (var i = 0; i < that.declareselist.length; i++) {
              if (that.declareselist[i].id == that.datalist.campusId) {
                that.declar = that.declareselist[i];
              }
            }
          }
          if (that.declareselist.length == 0) {
            Toast("您所在的学校没有可申报的校区，暂时不可申报！");
          }
        })
        .catch(() => {});
    },
    gradegradelist() {
      let that = this;
      let params = {
        schoolId: localStorage.getItem("schoolId"),
      };
      gradegradelist(params)
        .then((res) => {
          that.gradelist = res.data.data;
          if (that.$route.query.xq == 1) {
            for (var i = 0; i < that.gradelist.length; i++) {
              if (that.gradelist[i].gradeId == that.datalist.gradeId) {
                that.grade = that.gradelist[i];
              }
            }
          }
        })
        .catch(() => {});
    },
    declaresaveDeclareVideoTape() {
      let that = this;
      let time=new Date(this.beginTime).getTime();
      let time1=new Date(this.endTime).getTime();
      if (this.beginTime == "") {
        Toast("请选择录课开始时间！");
        return false;
      }
      if (this.endTime == "") {
        Toast("请选择录课结束时间！");
        return false;
      }
      if(this.beginTime>this.endTime){
        Toast("开始时间不能大于结束时间！");
        return false;
      }
      // if (!this.subjec.id) {
      //   Toast("请选择学科！");
      //   return false;
      // }
      if (!this.declar.id) {
        Toast("请选择校区！");
        return false;
      }
      // if (!this.grade.gradeId) {
      //   Toast("请选择年级！");
      //   return false;
      // }
      if (this.courseAddress == "") {
        Toast("请输入录课地点！");
        return false;
      }
      if (this.courseName == "") {
        Toast("请输入课程名称！");
        return false;
      }
      if (this.courseKeynote == "") {
        Toast("请输入课程介绍！");
        return false;
      }
      let params = {
        id:this.datalist.id,
        beginTime: this.beginTime,
        campusId: this.declar.id,
        campusName: this.declar.name,
        courseAddress: this.courseAddress,
        courseName: this.courseName,
        courseKeynote: this.courseKeynote,
        endTime: this.endTime,
        subjectId: this.subjec.id,
        subjectName: this.subjec.name,
        groupId: localStorage.getItem("groupId"),
        gradeId: this.grade.gradeId,
        gradeName: this.grade.name,
      };
      declaresaveDeclareVideoTape(params)
        .then((res) => {
          Dialog.alert({
            title: "申报成功",
            message:
              "您已成功提交，感谢您的参与！",
          }).then(() => {
            that.$router.push({
              path: "/declareindex",
            });
          });
        })
        .catch(() => {});
    },
    quxiao() {
      this.$router.push({
        path: "/declareindex",
      });
    },
    declareuploadCourseReflect(){
      let that = this;
      if (this.datalist.courseReflect == "") {
        Toast("请填写课后反思！");
        return false;
      }
      let params = {
        id: this.datalist.id,
        courseReflect: this.datalist.courseReflect
      };
      declareuploadCourseReflect(params)
        .then((res) => {
          Toast("课后反思提交成功！");
          that.show5=false
        })
        .catch(() => {});
    },
    fuzhi(s){
      this.violisy=s.serverHttp+s.fileUrl
      Dialog.alert({
        title: '可长按复制到浏览器下载/观看',
        message: this.violisy,
      }).then(() => {
        // on close
      });
    },
    tuichu(){
      let that = this;
      let params = {
        openid: localStorage.getItem("openid"),
      };
      usewxrlogout(params)
        .then((res) => {
          localStorage.setItem("token", '');
          let local=siteurl+"#/log"
              window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri="+ encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"
        })
        .catch(() => {});
    },
  },
  mounted() {
    let token = localStorage.getItem("token");
    this.title=localStorage.getItem("name");
    if(token==''||!token){
      let local=siteurl+"#/log"
              window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri="+ encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"
    }
    this.subjectgetSubjectBySchoolId();
    this.declareselectListByGroupId();
    this.gradegradelist();
    if (this.$route.query.xq == 1) {
      let data = localStorage.getItem("xq");
      data = JSON.parse(data);
      this.datalist = data;
      this.courseName = data.courseName;
      this.beginTime = data.beginTime;
      this.courseKeynote = data.courseKeynote;
      this.courseAddress = data.courseAddress;
      this.endTime = data.endTime;
    }
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/declare/declare.vue